import {
  SEGMENTS_LIST,
  SEGMENTS_LIST_SUCCESS,
  SEGMENTS_LIST_ERROR,
  SEGMENTS_NEW,
  SEGMENTS_NEW_SUCCESS,
  SEGMENTS_NEW_ERROR,
  SEGMENTS_EDIT,
  SEGMENTS_DELETE,
  SEGMENTS_DELETE_SUCCESS,
  SEGMENTS_DELETE_ERROR,
} from "./actionTypes"


export const segmentsList = data => ({
  type: SEGMENTS_LIST,
  payload: data
});

export const segmentsListSuccess = data => ({
  type: SEGMENTS_LIST_SUCCESS,
  payload: {data}
});

export const segmentsListError = error => ({
  type: SEGMENTS_LIST_ERROR,
  payload: error,
});

export const segmentsNew = data => ({
  type: SEGMENTS_NEW,
  payload: data
});

export const segmentsNewSuccess = data => ({
  type: SEGMENTS_NEW_SUCCESS,
  payload: {data}
});

export const segmentsNewError = error => ({
  type: SEGMENTS_NEW_ERROR,
  payload: error,
});

export const segmentsEdit = data => ({
  type: SEGMENTS_EDIT,
  payload: data
});

export const segmentsDelete = data => ({
  type: SEGMENTS_DELETE,
  payload: data
});

export const segmentsDeleteSuccess = data => ({
  type: SEGMENTS_DELETE_SUCCESS,
  payload: {data}
});

export const segmentsDeleteError = error => ({
  type: SEGMENTS_DELETE_ERROR,
  payload: error,
});
